"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONNECTION_ACTION;
(function (CONNECTION_ACTION) {
    CONNECTION_ACTION[CONNECTION_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    CONNECTION_ACTION[CONNECTION_ACTION["ERROR"] = 1] = "ERROR";
    CONNECTION_ACTION[CONNECTION_ACTION["PING"] = 2] = "PING";
    CONNECTION_ACTION[CONNECTION_ACTION["PONG"] = 3] = "PONG";
    CONNECTION_ACTION[CONNECTION_ACTION["ACCEPT"] = 4] = "ACCEPT";
    CONNECTION_ACTION[CONNECTION_ACTION["CHALLENGE"] = 5] = "CHALLENGE";
    CONNECTION_ACTION[CONNECTION_ACTION["REJECT"] = 6] = "REJECT";
    CONNECTION_ACTION[CONNECTION_ACTION["REDIRECT"] = 7] = "REDIRECT";
    CONNECTION_ACTION[CONNECTION_ACTION["CLOSING"] = 8] = "CLOSING";
    CONNECTION_ACTION[CONNECTION_ACTION["CLOSED"] = 9] = "CLOSED";
    CONNECTION_ACTION[CONNECTION_ACTION["AUTHENTICATION_TIMEOUT"] = 100] = "AUTHENTICATION_TIMEOUT";
    CONNECTION_ACTION[CONNECTION_ACTION["INVALID_MESSAGE"] = 101] = "INVALID_MESSAGE";
})(CONNECTION_ACTION = exports.CONNECTION_ACTION || (exports.CONNECTION_ACTION = {}));
//# sourceMappingURL=connection.js.map